import PropTypes from 'prop-types'
import React from 'react'

import { toRoman } from 'helpers'

import { SORTIE_LEVELS } from 'constants'

import styles from './Level.scss'

const Level = (props) => {
    return (
        <div className={styles.base} data-tip data-for={props.tooltipId}>
            <span className={styles.icon}>
                {toRoman(SORTIE_LEVELS[props.level])}
                <span className={styles['icon-shadow']}>{toRoman(SORTIE_LEVELS[props.level])}</span>
            </span>
        </div>
    )
}

Level.propTypes = {
    // WGSH-2679 replace string property into integer and use data from response
    level: PropTypes.string.isRequired,
    tooltipId: PropTypes.string.isRequired,
}

export default Level



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Level/Level.jsx